import { shellIcons } from '@dashboard/components/icons/shellIcons'
import { useConnectedMetaAds } from '@dashboard/modules/ads/adsAccess'
import { OTHER_DASHBOARDS } from '@dashboard/modules/dashboard/services/otherDashboards'
import { useHostedPagesAccess } from '@dashboard/modules/pages/pagesAccess'
import { LEAD_ALERTS_PERMISSION, PEOPLE_PAGES_PERMISSION } from '@dashboard/modules/visitors/peoplePagesAccess'
import { ROUTES } from '@dashboard/router/routeNames'
import { usePermissionStore } from '@dashboard/stores/permissionStore'
import { computed } from 'vue'

const useSidebarNavigation = () => {
  const { canAccess } = usePermissionStore()
  const hostedPagesVisible = useHostedPagesAccess()
  const metaAds = useConnectedMetaAds()

  return computed(() => [
    {
      name: 'Dashboard',
      to: { name: ROUTES.DASHBOARD },
      icon: shellIcons.home,
      // Shown beneath Dashboard only while it or one of these is open.
      children: OTHER_DASHBOARDS
    },
    // Without People pages, lead alerts (on every plan) take People's place.
    ...(canAccess(PEOPLE_PAGES_PERMISSION)
      ? [
          {
            name: 'People',
            to: { name: ROUTES.PEOPLE },
            icon: shellIcons.people
          }
        ]
      : canAccess(LEAD_ALERTS_PERMISSION)
        ? [
            {
              name: 'Lead alerts',
              to: { name: ROUTES.LEAD_ALERTS },
              icon: shellIcons.bell,
              badge: 'New'
            }
          ]
        : []),
    { name: 'Enrich', type: 'divider' },
    {
      name: 'Segments',
      to: { name: ROUTES.SEGMENTGROUPS },
      icon: shellIcons.segments
    },
    {
      name: 'Questions',
      to: { name: ROUTES.QUESTIONS },
      icon: shellIcons.questions
    },
    {
      name: 'Responses',
      to: { name: ROUTES.RESPONSES },
      icon: shellIcons.responses
    },
    { name: 'Convert', type: 'divider' },
    {
      name: 'Flows',
      to: { name: ROUTES.OFFERFUNNELS },
      icon: shellIcons.flows
    },
    {
      name: 'Widgets',
      to: { name: ROUTES.WIDGETS },
      icon: shellIcons.widgets
    },
    ...(hostedPagesVisible.value
      ? [
          {
            name: 'Pages',
            to: { name: ROUTES.PAGES },
            icon: shellIcons.pages
          }
        ]
      : []),
    {
      name: 'Forms',
      to: { name: ROUTES.FORMS },
      icon: shellIcons.forms
    },
    {
      name: 'Offers',
      to: { name: ROUTES.OFFERS },
      icon: shellIcons.offers
    },
    { name: 'Personalize', type: 'divider' },
    {
      name: 'Emails',
      to: { name: ROUTES.EMAILS },
      icon: shellIcons.emails,
      requiredFeature: 'personalized_emails'
    },
    {
      name: 'Campaigns',
      to: { name: ROUTES.CAMPAIGNS },
      icon: shellIcons.campaigns,
      requiredFeature: 'campaigns'
    },
    ...(metaAds.value
      ? [
          {
            name: 'Ads',
            to: { name: ROUTES.ADS },
            icon: shellIcons.ads,
            requiredFeature: metaAds.value.listing.requiredFeature
          }
        ]
      : []),
    {
      name: 'Conversion Goals',
      to: { name: ROUTES.GOALS },
      icon: shellIcons.goals,
      requiredFeature: 'goals'
    },
    { name: 'Optimize', type: 'divider' },
    {
      name: 'Growth Ideas',
      to: { name: ROUTES.GROWTH_IDEAS },
      icon: shellIcons.ideas,
      requiredFeature: 'full_analytics'
    },
    {
      name: 'Optimizations',
      to: { name: ROUTES.OPTIMIZATIONS },
      icon: shellIcons.optimizations
    },
    {
      name: 'A/B Testing',
      to: { name: ROUTES.SPLIT_TESTS },
      icon: shellIcons.abTesting
    }
  ])
}

export { useSidebarNavigation }
